import { render, staticRenderFns } from "./RaddarChart.vue?vue&type=template&id=47b943a8"
import script from "./RaddarChart.vue?vue&type=script&lang=js"
export * from "./RaddarChart.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports